import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteCourseDetailedTabsV2Component} from './website-course-detailed-tabs-v2.component'
import {SharedModule} from '../shared/shared.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {NgxJsonLdModule} from 'ngx-json-ld'
import {RichsnipetService} from 'dmmp-services'
@NgModule({
  declarations: [WebsiteCourseDetailedTabsV2Component],
  imports: [
    CommonModule,
    SharedModule,
    NgbNavModule,
    NgxJsonLdModule
  ],
  exports: [
    WebsiteCourseDetailedTabsV2Component
  ],
  providers: [RichsnipetService],
})
export class WebsiteCourseDetailedTabsV2Module {
}
